import {ValueObject} from '@s-ui/domain'

import AdEntityLegacy from '../Entities/AdEntityLegacy.js'

export class AdListValueObjectLegacy extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({value}) {
    return new AdListValueObjectLegacy({
      value: value.map(data => AdEntityLegacy.create(data))
    })
  }

  static createFromRecommendedAds({value}) {
    return new AdListValueObjectLegacy({
      value: value.map(data => AdEntityLegacy.createFromRecommendedAd({ad: data}))
    })
  }

  get value() {
    return this.#value.map(ad => ad.value)
  }

  toJSON() {
    return {value: this.#value.map(data => data.toJSON())}
  }
}
